<template>
  <div class="date-selector">
    <el-radio-group v-model="durationType" style='margin-right: 120px;'>
      <el-radio-button label="0">本周</el-radio-button>
      <el-radio-button label="1">上周</el-radio-button>
      <el-radio-button label="2">本月</el-radio-button>
      <el-radio-button label="3">上月</el-radio-button>
    </el-radio-group>

    <el-date-picker
      v-model="durationDate"
      type="daterange"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      @change="changeDurationType"
      :clearable='false'
    ></el-date-picker>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      duration: [],
      durationType: 4,
      durationDate: [],
      type: "",
      data: ""
    };
  },
  watch: {
    durationType(val) {
      if (val == 4) {
        return;
      }
      this.durationDate = [];
      this.duration = this.computeDate(val);
      this.$emit("dateChange", this.duration);
    }
  },
  computed: {},
  methods: {
    changeDurationType(val) {
      this.durationType = 4;
      this.$emit("dateChange", val);
    },
    computeDate(type) {
      var date = new Date();
      var now = this.formatISODate(date);
      var day = date.getDay();
      var month = date.getMonth();
      var aDay = 1000 * 60 * 60 * 24;
      var msTime = date.getTime();
      
      // 已周日为开始
      // if(type == 0) {
      //   let start = this.formatISODate(new Date(msTime - day * aDay));
      //   let end = this.formatISODate(new Date(msTime + (6 - day) * aDay))
      //   return [start, end]
      // } else if (type == 1) {
      //   let start = this.formatISODate(new Date(msTime - (day + 7) * aDay));
      //   let end = this.formatISODate(new Date(msTime + (6 - day - 7) * aDay))
      //   return [start, end]
      // } else if (type == 2) {
      //   return this.computeMonth(date)
      // } else if (type == 3) {
      //   date = new Date(date.setMonth(month - 1))
      //   return this.computeMonth(date)
      // }

      // 已周一为开始
      if(day == 0) {
        day = 7
      }
      if (type == 0) {
        let start = this.formatISODate(new Date(msTime - (day - 1) * aDay));
        let end = this.formatISODate(new Date(msTime + (7 - day) * aDay));
        return [start, end];
      } else if (type == 1) {
        let start = this.formatISODate(new Date(msTime - (day - 1) * aDay - 7 * aDay));
        let end = this.formatISODate(new Date(msTime - (day) * aDay));
        return [start, end];
      } else if (type == 2) {
        return this.computeMonth(date);
      } else if (type == 3) {
        date = new Date(date.setMonth(month - 1));
        return this.computeMonth(date);
      }
    },
    formatISODate(date) {
      // return date.toISOString().match(/\d+-\d+-\d+/g)[0];
      let yy = date.getFullYear()
      let MM = 1 + (+date.getMonth()) 
      let dd = date.getDate()
      return `${yy}-${MM}-${dd}`
    },
    computeMonth(date) {
      var month = date.getMonth();
      var mon = [
        "31",
        "28",
        "31",
        "30",
        "31",
        "30",
        "31",
        "31",
        "30",
        "31",
        "30",
        "31"
      ];
      var now = date.toISOString().match(/\d+-\d+-/g)[0];
      if (this.isLeapYear(date.getFullYear())) {
        mon[1] = "29";
      }
      var start = now + "01";
      var end = now + mon[month];
      return [start, end];
    },
    isLeapYear(Year) {
      if ((Year % 4 == 0 && Year % 100 != 0) || Year % 400 == 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  beforeCreate() {},
  created() {
    this.durationType = 0;
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>

</style>